export const FETCH_CLIENT_MAPPED_PRODCUT_REQUEST = 'FETCH_CLIENT_MAPPED_PRODCUT_REQUEST';
export const FETCH_CLIENT_MAPPED_PRODCUT_SUCCESS = 'FETCH_CLIENT_MAPPED_PRODCUT_SUCCESS';
export const FETCH_CLIENT_MAPPED_PRODCUT_FAILURE = 'FETCH_CLIENT_MAPPED_PRODCUT_FAILURE';

export const SET_SELECTED_CLIENT_DATA = "SET_SELECTED_CLIENT_DATA"